const lnbData = [ // Navigation Depth List
    {
        name: '홈',
        path: '/admin/main'
    },
    {
        name: '약재관리',
        path: '',
        children: [{
                name: '약재등록',
                path: '/admin/medicine/medicineMngt',
            },
            {
                name: '제품코드등록',
                path: '/admin/medicine/ProductCodeMngt',
            },
            {
                name: '약재입고하기',
                path: '/admin/medicine/MedicineWrhsMngt',
            },
            {
                name: '약재재고관리',
                path: '/admin/medicine/MedicineStockMngt',
            },
            {
                name: '약재사용현황',
                path: '/admin/medicine/herbUsageReport',
            },
        ]
    },
    {
        name: '방제사전관리',
        path: '',
        children: [
            {
                name: '방제사전관리',
                path: '/admin/dictionary/dictionaryMngt',
            },
            {
                name: '첩약건보사전관리',
                path: '/admin/dictionary/insuranceDictionaryMngt',
            },
            {
                name: '비방사전관리',
                path: '/admin/dictionary/secretPrescriptionMngt',
            },
        ]
    },
    {
        name: '약속상품관리',
        path: '',
        children: [{
                name: '신규 약속상품관리',
                path: '/admin/promise/promiseGoodsMngt',
            },
            {
                name: '신규 약속상품 품목관리',
                path: '/admin/promise/promiseGoodsItemList',
            },
            {
                name: '약속상품생산관리',
                path: '/admin/promise/promiseGoodsWrhsMngt',
            },
            {
                name: '약속상품조제하기',
                path: '/admin/promise/promiseGoodsWrhsWorkMngt',
            },
        ]
    },
    {
        name: '포장재관리',
        path: '',
        children: [{
                name: '포장상품관리',
                path: '/admin/wrapper/WrapperMngt',
            },
            {
                name: '포장입고관리',
                path: '/admin/wrapper/WrapperWrhsMngt',
            },
        ]
    },
    {
        name: '업무관리',
        path: '',
        children: [{
                name: '업무진행현황',
                path: '/admin/work/WorkStatusList',
        }   ,{
                name: '조제처리',
                path: '/admin/work/PharmacyMngt',
            },
            // {
            //     name: '탕전처리',
            //     path: '',
            // },
            {
                name: '포장배송',
                path: '/admin/work/WrapperDeliveryMngt',
            },
        ]
    },
    {
        name: '게시판관리',
        path: '',
        children: [{
                name: '공지사항관리',
                path: '/admin/board/noticeMngt',
            },
            {
                name: '자료실관리',
                path: '',
            },
            {
                name: 'QnA관리',
                path: '/admin/board/qnaMngt',
            },
        ]
    },
    {
        name: '컨텐츠관리',
        path: '',
        children: [
            {
                name: '둘러보기관리',
                path: '/admin/contents/aroundMngt',
            },
            {
                name: '처방문의관리',
                path: '/admin/contents/formulaQnaMngt',
            }
        ]
    },
    {
        name: '고객관리',
        path: '',
        children: [{
                name: '회원정보관리',
                path: '/admin/userMngt/userMngtList',
            },
            {
                name: '사전처방관리',
                path: '',
            },
            {
                name: '예치금관리',
                path: '/admin/userMngt/userDepositList',
            },
            {
                name: '포인트관리',
                path: '/admin/userMngt/userPointList',
            },
        ]
    },
    {
        name: '주문결제관리',
        path: '',
        isOpen: false,
        children: [{
                name: '탕전주문관리',
                path: '/admin/orderPayment/orderTangjunList',
            },
            {
                name: '약속상품주문관리',
                path: '/admin/orderPayment/orderPromiseList',
            },
            {
                name: '결제관리',
                path: '',
            },
        ]
    },
    {
        name: '시스템관리',
        path: '',
        children: [{
                name: '코드관리',
                path: '/admin/system/codeMngt',
            },
            {
                name: '권한관리',
                path: '',
            },
        ]
    },
]

export { lnbData }